import { ArrowRight, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackEvent, EVENTS } from "@/utils/track";

export default function FinalCta() {
  return (
    <section className="bg-navy py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h2
          data-testid="final-cta-title"
          className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-[2.6rem] lg:leading-[1.15]"
        >
          Deja de aceptar horas de sillón vacías como si fueran inevitables.
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-[#C3D2E6] sm:text-lg">
          Descubre cuántas citas puedes recuperar con confirmación inteligente, predicción
          de riesgo y rescate automático de cancelaciones.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button
            asChild
            data-testid="final-cta-primary"
            size="lg"
            className="w-full whitespace-normal rounded-lg bg-white px-8 py-6 text-base font-semibold text-navy shadow-lg transition-all duration-200 hover:bg-platinum sm:w-auto"
            onClick={() => trackEvent(EVENTS.CTA_PRINCIPAL, { ubicacion: "cta_final" })}
          >
            <a href="#calculadora">
              Calcula tus pérdidas
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
          <Button
            asChild
            data-testid="final-cta-secondary"
            size="lg"
            variant="outline"
            className="w-full whitespace-normal rounded-lg border-white/30 bg-transparent px-8 py-6 text-base font-semibold text-white transition-all duration-200 hover:border-white hover:bg-white/10 sm:w-auto"
            onClick={() => trackEvent(EVENTS.CTA_PRINCIPAL, { ubicacion: "cta_final_demo" })}
          >
            <a href="#auditoria">
              <CalendarCheck className="mr-2 h-4 w-4" />
              Solicita una demostración
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
